var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    d: "M29.731 17.134a12.69 12.69 0 0 0-5.4-9.067 1.206 1.206 0 0 1-.3-1.683 1.206 1.206 0 0 1 1.684-.3 15.192 15.192 0 0 1 6.433 10.8 1.216 1.216 0 0 1-1.084 1.333h-.133a1.21 1.21 0 0 1-1.2-1.083ZM3.117 18.3a1.216 1.216 0 0 1-1.084-1.334A15.14 15.14 0 0 1 8.367 6.149a1.22 1.22 0 0 1 1.683.284c.383.55.25 1.3-.283 1.683-3 2.133-4.95 5.433-5.317 9.083-.067.634-.6 1.1-1.217 1.1h-.116Zm13.985 15.351c-2.4 0-4.684-.533-6.817-1.616-.6-.284-.833-1.017-.533-1.617.283-.6 1.016-.833 1.616-.55 1.05.533 2.167.9 3.3 1.117 1.534.3 3.1.316 4.634.05 1.133-.2 2.25-.55 3.283-1.05.617-.284 1.35-.05 1.617.566.3.6.066 1.334-.55 1.617a15.013 15.013 0 0 1-6.55 1.483Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.383 5.05c0 2.6 2.1 4.7 4.7 4.7s4.7-2.1 4.7-4.7-2.1-4.7-4.7-4.7c-2.584 0-4.7 2.1-4.7 4.7ZM.719 24.817c0 2.6 2.1 4.7 4.7 4.7s4.7-2.1 4.7-4.7-2.117-4.7-4.7-4.7c-2.584 0-4.7 2.1-4.7 4.7Zm23.168 0c0 2.6 2.1 4.7 4.7 4.7s4.7-2.1 4.7-4.7-2.1-4.7-4.7-4.7c-2.584 0-4.7 2.1-4.7 4.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundIcon);
export default __webpack_public_path__ + "static/media/roundIcon.1af08a782bb8e1a17ade24e888d8eff1.svg";
export { ForwardRef as ReactComponent };